import { ContactInfo, ContactForm } from "../components/ContactParts";

function ContactHero() {
  return (
    <section
      className="relative h-[50vh] min-h-[380px] flex items-center justify-center text-center bg-cover bg-center"
      style={{
        backgroundImage:
          "linear-gradient(rgba(10,36,36,0.72), rgba(10,36,36,0.9)), url(/image/siteimages/gallery/2880x2304Selects/SeaSpiceKitchen_GarlicPrawns_2880x2304.jpg)"
      }}
    >
      <div className="relative pt-20">
        <span className="divider-ornament text-spice-gold">Get In Touch</span>
        <h1 className="font-display text-white text-5xl md:text-6xl lg:text-7xl font-medium mt-5">
          Contact Us
        </h1>
        <p className="text-white/75 mt-4 max-w-xl mx-auto text-base px-5">
          We&apos;d love to hear from you — reach out for bookings, enquiries or events.
        </p>
      </div>
    </section>
  );
}

function ContactMap() {
  return (
    <section className="h-[450px] w-full bg-sea-deep">
      <iframe
        title="Sea Spice Kitchen location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50375.8!2d145.122!3d-38.144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sFrankston%20VIC!5e0!3m2!1sen!2sau!4v1700000000000"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </section>
  );
}

export default function Contact() {
  return (
    <>
      <ContactHero />
      <section className="py-20 lg:py-28 bg-cream">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20">
          <ContactInfo />
          <ContactForm />
        </div>
      </section>
      <ContactMap />
    </>
  );
}
